import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import { mergeClasses, Body1Stronger, Subtitle1, TableCell } from '@fluentui/react-components';
import { LockOpenRegular, LockClosedRegular, ClockRegular } from '@fluentui/react-icons';
import { AddFilled } from "@fluentui/react-icons";
import {format} from "date-fns";
import './Timesheet.css';

export default function EntryCell(props) {      
    const{ useStyles, isDesktop }= useGlobalStatus();
    const classes = useStyles();
    const totalMinutes = props.data.totalMinutes ?? 0;

    const handleEntryClick=()=>{
        if (isDesktop? props.handleEntryCellAction(props.data) : props.handleEntryCellAction(props.timecodeData, props.data));
    }; 

    const statusToStyleMap = {
        empty: classes.empty,
        open: classes.open,
        error: classes.error,
        closed: classes.closed,
        rejected: classes.rejected,
        approved: classes.approved,
        outOfProjectRange: classes.outOfProjectRange,
        outOfUserRange: classes.outOfUserRange,
        outOfTimecodeRange: classes.outOfTimecodeRange
    };

    const style = statusToStyleMap[props.data.status] ?? classes.error;

    const renderEntryCellBodyError = () => {
        switch (props.data.status) {
          case 'outOfProjectRange':
            return <Body1Stronger>Date out of Project start/end</Body1Stronger>
          case 'outOfTimecodeRange':
            return <Body1Stronger>Date out of Timecode start/end</Body1Stronger>
          case 'outOfUserRange':
            return <Body1Stronger>Date out of Employee start/end</Body1Stronger>
          default:
            return <Body1Stronger>Error, click to correct</Body1Stronger>;
        }
      };

    switch (true) {
        case (!isDesktop):
            switch (true) {
        case (new Date(props.data.date) <= new Date('2025-08-31')):
            return (
                <></>
            )
        case (props.data.casualMonthLocked):
            return <TableCell className={mergeClasses('entrycell', classes.closed)} >
                <div className={mergeClasses('entrycell', classes.closed)} 
                style={{gridColumn: 'span 1', flexDirection: 'column'}}>
                <div className='title'>
                    <div>
                        <LockClosedRegular className={classes.icon18} />
                    </div>
                </div>
                <div className='body'>
                    <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                </div>
            </div>     
            </TableCell>
        case (props.data.status==="empty" ):
            return (            
                <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}} 
                    onClick={()=> handleEntryClick()}>
                    <div className='title'>
                        {!isDesktop? format(props.data.date, "E do").toString() : <br/>}
                    </div>
                    <div className='body'>
                        <AddFilled></AddFilled>
                    </div>
                </div>   
            )
        case (props.data.status==="open" || props.data.status==="rejected"):
            return (
                <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}} 
                    onClick={()=> handleEntryClick()}>
                    <div className='title'>
                        {!isDesktop && format(props.data.date, "E do").toString()}
                        <div>{props.data.status==="closed" ? <LockClosedRegular className={classes.icon18} /> : <LockOpenRegular className={classes.icon18} />}</div>
                    </div>
                    <div className='body'>
                        <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                    </div>
                </div>   
            )
        case (props.data.status==="closed" || props.data.status==="approved"):
            return (                
                <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}}>
                    <div className='title'>
                        {!isDesktop && format(props.data.date, "E do").toString()}
                        <div>
                            {props.data.status==="closed" || "approved" ? <LockClosedRegular className={classes.icon18} /> : <LockOpenRegular className={classes.icon18} />}
                        </div>
                    </div>
                    <div className='body'>
                        <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                    </div>
                </div>       
            )
        default:
            return (                
                <div className={mergeClasses('entrycell', style)} 
                    style={{
                        gridColumn: 'span 1',                    
                        alignItems:'center',
                        alignContent:'stretch',
                        justifyContent: 'center'}}
                    onClick={()=> props.data.status === 'error' && handleEntryClick()}>
                    {renderEntryCellBodyError()}
                </div>           
            )
    }
        case (new Date(props.data.date) <= new Date('2025-08-31')):
            return (                
                <TableCell className={mergeClasses('entrycell', style)}>
                    <div className={mergeClasses('entrycell', style)} 
                    style={{
                        gridColumn: 'span 1',                    
                        alignItems:'center',
                        alignContent:'stretch',
                        justifyContent: 'center'}} ></div>
                </TableCell>
            )
        case (props.data.casualMonthLocked):
            return <TableCell className={mergeClasses('entrycell', classes.closed)} >
                <div className={mergeClasses('entrycell', classes.closed)} 
                style={{gridColumn: 'span 1', flexDirection: 'column'}}>
                <div className='title'>
                    <div>
                        <LockClosedRegular className={classes.icon18} />
                    </div>
                </div>
                <div className='body'>
                    <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                </div>
            </div>     
            </TableCell>
        case (props.data.status==="empty" ):
            return (         
                <TableCell onClick={()=> handleEntryClick()} className="table-entry-cell-hover">
                <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}} 
                    onClick={()=> handleEntryClick()}>
                    <div className='title'>
                    </div>
                    <div className='body'>
                        <AddFilled className="entry-plus"></AddFilled>
                    </div>
                </div>   
                </TableCell>   
            )
        case (props.data.status==="open" || props.data.status==="rejected"):
            return (
                <TableCell onClick={()=> handleEntryClick()} className="table-entry-cell-hover">
                    <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}} 
                    onClick={()=> handleEntryClick()}>
                    <div className='title'>
                        <LockOpenRegular className={classes.icon18} />
                    </div>
                    <div className='body'>
                        <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                    </div>
                </div>   
                </TableCell>
            )
        case (props.data.status==="closed" || props.data.status==="approved"):
            return (                
                <TableCell className={mergeClasses('entrycell', style)} >
                    <div className={mergeClasses('entrycell', style)} 
                    style={{gridColumn: 'span 1', flexDirection: 'column'}}>
                    <div className='title'>
                        <div>
                            {props.data.status==="closed" || "approved" ? <LockClosedRegular className={classes.icon18} /> : <LockOpenRegular className={classes.icon18} />}
                        </div>
                    </div>
                    <div className='body'>
                        <div><ClockRegular className={classes.icon18}/><Subtitle1>{(Math.round(totalMinutes / 60 * 100) / 100).toFixed(2)}hr</Subtitle1></div>
                    </div>
                </div>     
                </TableCell>
            )
        default:
            return (     
                <TableCell className={mergeClasses('entrycell', style)} >      
                <div className={mergeClasses('entrycell', style)} 
                    style={{
                        gridColumn: 'span 1',                    
                        alignItems:'center',
                        alignContent:'stretch',
                        justifyContent: 'center'}}
                    onClick={()=> props.data.status === 'error' && handleEntryClick()}>
                    {renderEntryCellBodyError()}
                </div>      
                </TableCell>          
            )
    }
}